import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store/store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                authRequired: true,
            },
        },
        {
            path: '/sign-in',
            name: 'signin',
            component: () => import('./views/Signin.vue'),
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('./views/Users.vue'),
            meta: {
                authRequired: true,
            },
        },
        {
            path: '/catalogo_aocs',
            name: 'catalogo_aocs',
            component: () => import('./views/CatalogoAOCS.vue'),
            meta: {
                authRequired: true,
            },
        },
        {
            path: '/divisiones',
            name: 'divisiones',
            component: () => import('./views/Divisiones.vue'),
            meta: {
                authRequired: true,
            },
        },
        {
            path: '/autologin/:cuenta?/:carrera?',
            name: 'autologin',
            component: () => import('./views/Autologin.vue'),
        },
        {
            path: '/re-enter',
            name: 're-enter',
            component: () => import('./views/Reenter.vue'),
        },

        { path: '/redirect-me', redirect: { name: 'signin' } },
        { path: '*', redirect: '/sign-in' },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.authRequired)) {
        if (!store.state.idToken) {
            next({
                path: '/sign-in',
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
